export class switchLayoutService {
    constructor(private feedListId: string, private containerId: string) {}

    init() {
        const parentContainer = document.getElementById(this.containerId);
        const layoutChangeToggles = parentContainer?.querySelectorAll(".layout-change-toggle") as NodeListOf<HTMLAnchorElement>;
        const feedListDisplayDiv = document.getElementById(this.feedListId);

        if (!feedListDisplayDiv) {
            console.error(`Element with ID "${this.feedListId}" not found.`);
            return;
        }

        layoutChangeToggles?.forEach((toggle) => {
            toggle.addEventListener("click", () => this.handleLayoutChange(toggle, feedListDisplayDiv));
        });
    }

    private handleLayoutChange(toggle: HTMLAnchorElement, feedListDisplayDiv: HTMLElement) {
        const viewType = toggle.getAttribute("data-view_type");
        if (!viewType) return;

        const parent = toggle.parentElement;
        const feedParent = feedListDisplayDiv.parentElement;

        if (!parent || !feedParent) return;

        parent.classList.add(viewType);
        feedParent.classList.add(viewType);

        const oppositeView = viewType === "is-grid" ? "is-list" : "is-grid";
        parent.classList.remove(oppositeView);
        feedParent.classList.remove(oppositeView);
    }

    loadHTML() {
        const container = document.getElementById(this.containerId);
        if (!container) {
            console.error(`Container with ID "${this.containerId}" not found.`);
            return;
        }

        container.innerHTML = `
            <div class="group is-grid hidden md:inline-flex items-center border rounded-lg p-1 gap-[2px] dark:border-neutral-700">
                <a data-view_type="is-grid" title="Grid View"
                    class="layout-change-toggle size-[24px] rounded hover:bg-gray-100 text-dark flex items-center justify-center cursor-pointer dark:text-neutral-500 dark:hover:bg-neutral-900 group-[.is-grid]:bg-gray-100 group-[.is-grid]:text-dark dark:group-[.is-grid]:dark:bg-neutral-900 dark:group-[.is-grid]:text-neutral-500">
                    <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-layout-grid">
                    <rect width="7" height="7" x="3" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="14" rx="1" />
                    <rect width="7" height="7" x="3" y="14" rx="1" />
                    </svg>
                </a>
                <a data-view_type="is-list" title="List View"
                    class="layout-change-toggle size-[24px] rounded hover:bg-gray-100 text-dark flex items-center justify-center cursor-pointer dark:text-neutral-500 dark:hover:bg-neutral-900 group-[.is-list]:bg-gray-100 group-[.is-list]:text-dark dark:group-[.is-list]:dark:bg-neutral-900 dark:group-[.is-list]:text-neutral-500">
                    <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-align-justify">
                    <path d="M3 12h18" />
                    <path d="M3 18h18" />
                    <path d="M3 6h18" />
                    </svg>
                </a>
            </div>
        `;
    }
}